import { useQuery } from '@tanstack/react-query';
import { getMySections, type MySectionsResponse } from '../api/mySections';

export const useMySections = (bookId: number | undefined, options: { enabled?: boolean } = {}) => {
    return useQuery<MySectionsResponse, Error>({
        queryKey: ['my-sections', bookId],
        queryFn: () => getMySections(bookId as number),
        enabled: options.enabled !== false && !!bookId,
        // Progress can change while the user is away reading a section.
        // Keep the query refreshable when the learning path is re-entered.
        staleTime: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
    });
};
